module.exports = __webpack_public_path__ + "img/bi.22e5c070.png";